import { Circle, Heading, Image, StackProps, Text, VStack } from '@chakra-ui/react';
import { Icon, IconKey } from './Icon';

export interface Props {
  icon?: IconKey;
  imagePath?: string;
  heading: string;
  description: string;
  children?: React.ReactNode;
}

function EmptyStateIcon({ icon }: { icon: IconKey }) {
  return (
    <Circle minW="48px" minH="48px" bgColor="gray.50" border="1px solid" borderColor="gray.300">
      <Icon icon={icon} color="gray.300" size={6} />
    </Circle>
  );
}

export function EmptyState({ icon, imagePath, heading, description, children, ...inheritedProps }: Props & StackProps) {
  return (
    <VStack spacing={4} {...inheritedProps}>
      { imagePath ? <Image src={imagePath} w="100px" h="100px" /> : icon && <EmptyStateIcon icon={icon} /> }

      <VStack spacing={3}>
        <Heading size="sm" lineHeight="16px">{heading}</Heading>

        <Text maxW={440} color="gray.400" whiteSpace="pre-line" textAlign="center">
          { description }
        </Text>
      </VStack>

      { children }
    </VStack>
  );
}